module.exports = __webpack_public_path__ + "img/gallery-7.ce1d63ae.jpg";